import { FormHandle } from '@/hooks/use-form-handle.hook';
import { getMetadataControlActionOptions } from '@/lib/models/policy-model/metadata-controls';
import { PolicyModel } from '@/lib/models/policy-model/policy.model';
import { FC } from 'react';
import ServiceControlItem from './item';
import IntercomButton from '@/components/intercom/intercom-button';

interface Props {
  formHandle: FormHandle<PolicyModel>;
  readonly: boolean;
  withNotSet?: boolean;
}

const LicenseControlItem: FC<Props> = ({ formHandle, readonly, withNotSet = true }) => {
  const DescriptionEl = (
    <>
      Choose the action to apply to allowed requests that do not meet the business license
      requirement. Not all services support license classification.{' '}
      <IntercomButton intercomArticle="license-classification" label="Learn More" flatButton />
    </>
  );

  return (
    <ServiceControlItem
      formHandle={formHandle}
      readonly={readonly}
      label="Non-business License Control"
      description={DescriptionEl}
      controlType="non-licensed"
      options={getMetadataControlActionOptions('non-licensed')}
      withNotSet={withNotSet}
    />
  );
};

export default LicenseControlItem;
